// extracted by mini-css-extract-plugin
export default {"ctn":"scroll_ctn__b5Xfq","workBox":"scroll_workBox__em2Rd"};